import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/store";
import "../../css/testCenter.css";
import { useGetTestQuestionsMutation } from "../../store/testCenterSlice";
import { Button } from "antd";

interface TestDescriptionType {
  testLogId: string;
  testId: string;
  candidateId: string;
  testData: any;
  onCloseDescriptionModal: Function;
}

function TestDescription(props: TestDescriptionType) {
  const { testLogId, testId, candidateId, testData, onCloseDescriptionModal } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [getTestQuestions] = useGetTestQuestionsMutation();
  const location = useLocation();

  useEffect(() => {}, []);

  const onStartTest = () => {
    const payload = {
      id: testLogId,
    };
    getTestQuestions(payload)
      .unwrap()
      .then((question: any) => {
        console.log({ question });

        localStorage.removeItem("testId");
        localStorage.removeItem("responseId");
        localStorage.removeItem("candidateId");
        localStorage.removeItem("testSkill");

        localStorage.setItem("testId", testId);
        localStorage.setItem("responseId", question?.id);
        localStorage.setItem("candidateId", candidateId);
        localStorage.setItem("testSkill", testData.name);

        navigate("/testCenter/test-questions");
        // window.open("/testCenter/test-questions", "_blank");
      });
  };

  return (
    <div className="test_center__content" style={{ marginTop: "30px" }}>
      <div className="test_description_card_content_wrapper">
        <div className="test_description_card_content">
          <div className="test_description_card_content_text">
            <div style={{ marginBottom: "30px" }}>
              <text style={{ color: "grey", fontWeight: "500" }}>
                Based on your profile rank, we suggest you to take the following test to show your
                skill level to employers.
              </text>
            </div>
            <div>
              <text style={{ color: "grey", fontWeight: "500" }}>
                Our HR friends always wanted to talk to validated people first.
              </text>
            </div>
          </div>

          <div className="test_center_description_card">
            <div className="test_center_description_content">
              <div
                style={{
                  marginBottom: "10px",
                }}
                className="flex_column"
              >
                <text style={{ color: "blue", fontWeight: "500" }}>Skill Test</text>

                <text style={{ color: "black", fontWeight: "500" }}>{testData.name}</text>
              </div>

              <div className="flex_column" style={{ marginBottom: "20px" }}>
                <text style={{ color: "grey", fontWeight: "500" }}>DURATION</text>

                <text style={{ color: "black", fontWeight: "bold" }}>About 25 minutes</text>
              </div>
            </div>

            <div className="border_bottom_style" />
            <div
              className="will_do_it_later_btn"
              onClick={() => {
                onCloseDescriptionModal();
              }}
            >
              <text>I'll do it later</text>
            </div>
          </div>
          <div className="start_test_btn">
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              onClick={onStartTest}
            >
              Start Test
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestDescription;
